module.exports = __webpack_public_path__ + "static/media/20ECE13.c40b9b6f.jpg";